<div id="separator"></div>
<div [ngClass]="isMobile == true ? 'resolutions-holder-mob' : 'resolutions-holder'" style="margin-bottom: 24px;">
  <div class="top-holder">
    <h3 id="resolutions-header">{{'POLL-LIST.ONGOING' | translate}}</h3>
  </div>
  <app-event-item (selected)="setActiveElection($event)" *ngFor="let round of event.rounds; let i = index"
                          [index]="i" [votedData]="0" [isMobile]="isMobile" [round]="round" [votedStatus]="votedStatuses[i]">
  </app-event-item>
</div>
